var render = function render(){var _vm=this,_c=_vm._self._c;return _c('channel-form',{attrs:{"title":"Create Channel"},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }